import { project } from "./initializeStats";
import { statsArticle } from "./statsArticle";
import { inViewport } from "./elementsInViewport";
import { linkStats, setStatElementCollector, shareStats } from "./stats";
import { wideo } from "./wideo";
import { menu } from "./menu";
import { anchors } from "./anchors";
import { cutText, debounce } from "./helpers";
import { accordion, resizeAccordion } from "./widgets/accordion.js";
import { sliderSwiper } from "./widgets/slider";
import { loadTeasers } from "./loadTeasers.js";
import { validateAndSubmitForm } from "./widgets/form/form.js";
import { validateAndSubmitCastingForm } from "./widgets/form/castingForm.js";
import { scrollAnimations } from "./scrollAnimations.js";
import { accordionVertical } from "./widgets/accordionVertical.js";
import { splitWords } from "./splitWords.js";
import { btnAnimation } from "./btnAnimation.js";
import { countTextHeight } from "./widgets/countTextHeight.js";
import { toggleSound } from "./toggleSound.js";

setStatElementCollector();
anchors();
statsArticle();
linkStats();
inViewport();
shareStats();
wideo();
menu();
accordion();
accordionVertical();
sliderSwiper();
loadTeasers();
validateAndSubmitForm();
validateAndSubmitCastingForm();
scrollAnimations();
splitWords();
btnAnimation(document.querySelectorAll(".btn-main"));
countTextHeight();
toggleSound();

const changeSizesOnResize = () => {
  resizeAccordion();
  if (window.innerWidth < 521) {
    cutText(".section-teasers .teaser p", 70);
  }
};

window.addEventListener("resize", debounce(changeSizesOnResize, 500));

window.addEventListener("beforeunload", project.unloadData.bind(project));

window.addEventListener("DOMContentLoaded", () => {
  if (window.innerWidth < 521) {
    cutText(".section-teasers .teaser p", 70);
  }
});

// for testing
// document.querySelector('.header').addEventListener('click', project.unloadData.bind(project));
